<template>
  <div>
    <table>
      <colgroup>
        <col v-for="(th, index) in thead" :key="index" :width="th.width" />
      </colgroup>
      <tbody>
        <tr v-for="(item, index) in tableData" :key="index" ref="tdHeight">
          <template v-for="th in thead">
            <!-- 如果是布林值 -->
            <td
              :class="th.align == 'center' ? 'text_center' : ''"
              v-if="typeof item[th.value] === 'boolean'"
              :key="th.id"
            >
              <i class="el-icon-success text_center" v-if="item[th.value]"></i>
              <i class="el-icon-error text_center" v-else></i>
            </td>
            <!--如果是操作aciton的話-->
            <td
              :class="['action_btn',th.align == 'center' ? 'text_center' : '']"
              v-else-if="th.value == 'action'"
              :key="th.id"
            >
              <template
                v-if="$store.state.table.action&&$store.state.table.data.id==item.id&&$store.state.table.type=='edit'"
              >
                <Action :item="item" :th="{function:['pass','return']}"></Action>
              </template>
              <template v-else>
                <Action
                  v-if="th.function.includes('del')"
                  :item="item"
                  :th="{function:['edit','del']}"
                ></Action>
                <Action v-else :item="item" :th="{function:['edit']}"></Action>
              </template>
            </td>

            <td
              v-else-if="th.type==='user_select' && (!$store.state.table.action || ($store.state.table.data&&$store.state.table.data.id!==item.id))"
              :key="th.id"
            >{{item[`${th.value.split("_")[0]}_name`]}}</td>
            <!-- 有階層 -->
            <td v-else-if="Array.isArray(item[th.value])&& (!$store.state.table.action || ($store.state.table.data&&$store.state.table.data.id!==item.id))" :key="th.id">
              <!-- {{item[th.value]}} -->
              <template v-if="item[th.value].length!==0">
                <p v-for="(el,index) in item[th.value]" :key="index">
                  {{el.display_name}}
                </p>
              </template>
              <template v-else>
                還未設定
              </template>
            </td>
            <td :class="th.align == 'center' ? 'text_center' : ''" v-else :key="th.id">
              <template
                v-if="$store.state.table.action&&$store.state.table.data.id==item.id&&$store.state.table.type=='edit'"
              >
                <template v-if="th.type=='input'">
                  <input class="input_el-ment" type="text" v-model="item[th.value]" />
                </template>
                <template v-else-if="th.type=='textarea'">
                  <textarea class="input_el-ment" v-model="item[th.value]"></textarea>
                </template>
                <template v-else-if="th.type=='select'">
                  <el-select :size="'small'" v-model="item[th.value]" placeholder="類別">
                    <el-option v-for="item in th.options" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </template>
                <template v-else-if="th.type=='user_select'">
                  <el-select filterable :size="'small'" v-model="item[th.value]" placeholder="人員">
                    <el-option
                      v-for="item in th.options"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else-if="th.type=='other_select'">
                  <el-select
                    filterable
                    :size="'small'"
                    v-model="item[th.value]"
                    :placeholder="th.placeholder"
                  >
                    <el-option
                      v-for="item in th.options"
                      :key="item.id"
                      :label="item.display_name"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </template>
                <template v-else>{{ item[th.value] }}</template>
              </template>
              <template v-else>{{ item[th.value] }}</template>
            </td>
          </template>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<style lang="scss">
.text_center {
  text-align: center;
}
.action_btn {
  justify-content: center;
  align-items: center;
  .btn {
    width: 30px;
    height: 30px;
    padding: 0px;
    margin: 0 3px;
  }
}
.table_tab {
  margin: 5px 3px;

  padding: 5px 10px;
  border-radius: 5px;
  width: fit-content;
  min-width: 100px;
  max-width: 350px;
  font-size: 13px;
  align-items: center;
  p {
    font-weight: bold;
    font-size: 15px;
  }
  &.main {
    background: #f7dcdb;
  }
}
</style>
<script>
import Action from "./TableAction.vue";
export default {
  name: "table-main",
  components: {
    Action,
  },
  props: {
    thead: Array,
    tableData: Array,
  },
  data() {
    return {
      td_height_list: [],
      fixdColumnHeight: [],
      stash: [],
      action: null,
    };
  },
  methods: {
    updateTdHeight() {
      if (this.$refs.tdHeight) {
        this.td_height_list = this.$refs.tdHeight;
        const list = [];
        this.td_height_list.forEach((el, index) => {
          list.push(el.offsetHeight);
        });
        // this.fixdColumnHeight_Stach = list;
        // if (this.change) {
        //   this.columnHeightAction(list);
        // }
      }
    },
    columnHeightAction(list) {
      // this.change = false;
      this.fixdColumnHeight = list;
    },
  },
  updated() {
    // this.updateTdHeight();
  },
};
</script>
